// App download list - substitua os campos `downloadUrl` pelos seus links de APK
// quando estiverem prontos.

export const platformLabels = {
  android: "Android",
  androidtv: "Android TV",
  tvbox: "TV Box",
  firetv: "Fire TV",
};

export const downloadApps = [
  {
    id: "uniplay-uhd",
    name: "UniPlay UHD",
    description:
      "Aplicativo oficial UniPlay UHD. Funciona em celulares e tablets Android, Android TV, TV Box e Amazon Fire TV. Tenha acesso a filmes, séries, novelas e canais ao vivo em alta definição.",
    icon: "https://customer-assets.emergentagent.com/job_hardcore-lichterman-3/artifacts/zntek32k_images.png",
    bg: "#0a1a2f",
    downloads: 1247838,
    type: "apk",
    platforms: ["android", "androidtv", "tvbox", "firetv"],
    featured: true,
    downloadUrl:
      "https://customer-assets.emergentagent.com/job_hardcore-lichterman-3/artifacts/omo3d8dr_Uniplay%20uhd.apk",
  },
];
